import React from 'react';

import { AppRoutingAdmin } from 'containers/AppRouting/AppRoutingAdmin';
import { AppRoutingGuest } from 'containers/AppRouting/AppRoutingGuest';
import { AppRoutingClient } from 'containers/AppRouting/AppRoutingClient';
import { useUserRoles } from 'hooks/useUserRole';
import { useSignedIn } from 'hooks/useSignedIn';
import { useSignedOut } from 'hooks/useSignedOut';
import { useAuthProcess } from 'hooks/useAuthProcess';
import { AppRoutingPartner } from 'containers/AppRouting/AppRoutingPartner';
import { useAppEnvironmentProcess } from 'hooks/useAppEnvironmentProcess';

export const AppRoot = () => {
  useAuthProcess();
  useAppEnvironmentProcess();

  const signedOut = useSignedOut();

  const signedIn = useSignedIn();

  const userRoles = useUserRoles();

  if (signedIn && userRoles.includes('ADMIN')) {
    return <AppRoutingAdmin />;
  }

  if (signedIn && userRoles.includes('PARTNER')) {
    return <AppRoutingPartner />;
  }

  if (signedIn && userRoles.includes('CLIENT')) {
    return <AppRoutingClient />;
  }

  if (signedIn && userRoles.includes('PROMO')) {
    return <AppRoutingGuest />;
  }

  if (signedOut) {
    return <AppRoutingGuest />;
  }

  return null;
};
